import type { AskAIContext } from '@aidkitorg/typesheets/lib/askAI';

export function buildAskAIDraft(request: AskAIContext): string {
  const component = request.kind
    ? ` of the ${request.kind}${request.label ? ` ${JSON.stringify(request.label)}` : ''}`
    : '';
  return `I have a question about the \`${request.property}\` property${component}:\n\n`;
}

/** Resolve at send time, never embed a click-time array index in the editable draft. */
export function buildAskAIMessage(input: string, resolveContext: () => AskAIContext | null): string {
  const context = resolveContext();
  if (!context) return input;
  return `Selected config property: \`${context.path}\`.\n\n${input}`;
}
